export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";